import { render, staticRenderFns } from "./Bread.vue?vue&type=template&id=15d6e576&scoped=true"
import script from "./Bread.vue?vue&type=script&lang=js"
export * from "./Bread.vue?vue&type=script&lang=js"
import style0 from "./Bread.vue?vue&type=style&index=0&id=15d6e576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d6e576",
  null
  
)

export default component.exports